<template>
  <v-card class="elevation-12" v-model="show">
    <v-toolbar>
      <v-toolbar-title>{{$t('Login.LoginOverview.Label')}}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-form>
        <v-text-field v-model="loginData.credentials.email" :rules="[rules.required]" prepend-icon="person" name="login" label="E-Mail" type="text"></v-text-field>
        <v-text-field @keyup.enter="checkLogin()" v-model="loginData.credentials.password" :rules="[rules.required]" id="password" prepend-icon="lock" name="password" :label="$t('Login.LoginOverview.Password')" type="password"></v-text-field>
      </v-form>
      <v-checkbox v-model="loginData.stayLoggedIn" :label="$t('Login.LoginOverview.Remember-me')"></v-checkbox>
    </v-card-text>
    <v-card-text>
      <div>{{getError_message}}</div>
    </v-card-text>
    <div class="pa-0 display-flex">
      <div style="width: 50%; padding: 5px 2.5px 2.5px 5px">
        <v-btn width="100%" class="pa-1" @click="cancel()">{{$t('Buttons.cancel')}}</v-btn>
      </div>
      <div style="width: 50%; padding: 5px 5px 2.5px 2.5px">
        <v-btn width="100%"  v-if="!isLoading" @click="checkLogin()">{{$t('Buttons.Login')}}</v-btn>
        <LoadingButton v-else ></LoadingButton>
      </div>
    </div>
    <div style="width: 100%; padding: 2.5px 5px 2.5px 5px">
      <v-btn width="100%" @click="resetPassword()">{{$t('Login.LoginOverview.Reset-Password')}}</v-btn>
    </div>
    <v-card-actions v-if="isDevEnv">
      <v-btn v-if="!isLoading" @click="devLogin1()">DEV Login 1</v-btn>
      <v-btn v-if="!isLoading" @click="devLogin2()">DEV Login 2</v-btn>
      <LoadingButton v-if="isLoading" ></LoadingButton>
      <LoadingButton v-if="isLoading" ></LoadingButton>
    </v-card-actions>
  </v-card>
</template>

<script>
import environment from '@/helpers/environment.js';
import { mapActions, mapGetters} from 'vuex';
import validators from '../../helpers/validators'
import LoadingButton from '@/components/UserFeedback/LoadingButton.component.vue'
export default {
  components: {
    LoadingButton
  },
  props: [],
  data: () => ({
    show: true,
    loginData: {
      credentials: {
        email: '',
        password: '',
      },
      redirect_path: '',
      stayLoggedIn: false
    },
    rules: validators,
    isDevEnv: environment.isDevEnv
  }),
  computed: {
    ...mapGetters('Auth', [
      'isLoading',
      'getError_message'
    ])
  },
  methods: {
    devLogin1(){
      this.loginData.credentials.email = process.env.VUE_APP_DEV_LOGIN_1_EMAIL;
      this.loginData.credentials.password = process.env.VUE_APP_DEV_LOGIN_1_PASSWORD;
      this.checkLogin();
    },
    devLogin2(){
      this.loginData.credentials.email = process.env.VUE_APP_DEV_LOGIN_2_EMAIL;
      this.loginData.credentials.password = process.env.VUE_APP_DEV_LOGIN_2_PASSWORD;
      this.checkLogin();
    },
    checkLogin() {
      this.loginData.redirect_path = this.$route.query.redirect || 'home';
      this.login(this.loginData);
    },
    cancel() {
      this.setLoginShow(false);
      var self = this
      setTimeout(function () {
        self.$router.push({name: 'Home'})
      }, 150);
    },
    resetPassword(){
      this.setLoginShow(false);
      this.setTempUserEmail(this.loginData.credentials.email);
      this.$router.push({
        name: 'ResetPassword'
      })
    },
    ...mapActions('Auth', [
      'login'
    ]),
    ...mapActions('View', [
      'setLoginShow',
      'setTempUserEmail'
    ]),
  }
}
</script>
